












































































import {Vue, Component, Prop} from 'vue-property-decorator'

@Component
export default class BridgeErrorStep extends Vue {
  @Prop({type: String, required: true}) title!: string
  @Prop({type: String, required: true}) description!: string
}
